import React, { useContext } from "react"
import { Link } from "react-router-dom"
import TooltipTrigger from "../TooltipTrigger/TooltipTrigger"
import { WithT } from "i18next"
import { ROOT_CATEGORY_CODE } from "../../utility/knowledgeBase/knowledgeBase"
import { faChevronLeft } from "@fortawesome/pro-light-svg-icons/faChevronLeft"
import IconButton from "../IconButton/IconButton"
import { TreeItem } from "@atlaskit/tree/types"
import styles from "./CurrentBranch.module.scss"
import { buildKnowledgeBaseArticleUrl, buildSharedArticleActionUrl } from "../../utility/knowledgeBase/articleUrlHelper"
import { ArticleAction } from "../../models/article"
import KnowledgeBaseContext from "../KnowledgeBaseProvider/KnowledgeBaseContext"
import { testId } from "../../utility/tests/testId/knowledgeBase"

const tNamespace = "knowledgeBase:"

interface Props {
    parentCategory: TreeItem
    onParentClick: (parentCategory: TreeItem) => void
}

const CurrentBranch: React.FC<Props & WithT> = props => {
    const { parentCategory, onParentClick, t } = props

    const {
        data: { title: parentTitle, symbolCode }
    } = parentCategory

    const { url, shareId } = useContext(KnowledgeBaseContext)

    const buildArticleUrl = (symbolCode: string) =>
        shareId
            ? buildSharedArticleActionUrl(url, symbolCode)
            : buildKnowledgeBaseArticleUrl(url, ArticleAction.View, symbolCode)

    const title = parentTitle ? parentTitle : t(`${tNamespace}untitled`)

    const BranchTitle = (
        <TooltipTrigger id="current-branch" placement="bottom" content={title}>
            <IconButton
                className={styles.currentBranch}
                iconClassName={styles.currentBranch__parentIcon}
                variant="link"
                icon={faChevronLeft}
                iconSize="xs"
                hideIcon={symbolCode === ROOT_CATEGORY_CODE}
                testId={testId.currentBranchParentIcon}
            >
                <div className={styles.currentBranch__parentTitle}>{title}</div>
            </IconButton>
        </TooltipTrigger>
    )

    if (symbolCode === ROOT_CATEGORY_CODE) {
        return BranchTitle
    }

    return (
        <Link
            data-testid={testId.currentBranchParentLink}
            to={buildArticleUrl(symbolCode)}
            onClick={() => onParentClick(parentCategory)}
            className={styles.parentLink}
        >
            {BranchTitle}
        </Link>
    )
}

export default CurrentBranch
